/**
 * Преобразует тип сценария в предустановленные ответы для квиза
 * @param {string} scenarioType - Тип сценария ('short-trip', 'long-trip', 'unlimited', 'messengers', 'with-number', 'regional')
 * @returns {Object} Объект с предустановленными ответами для квиза
 */
export function scenarioToAnswers(scenarioType) {
    const answers = {};

    switch (scenarioType) {
        case 'short-trip':
            // Короткая поездка: 1-7 дней, небольшой трафик
            answers[0] = [0]; // Только в стране
            answers[1] = [0]; // 1-7 дней
            answers[2] = [0]; // До 5 ГБ
            break;

        case 'long-trip':
            // Долгая поездка: 30+ дней, большой трафик
            answers[0] = [0]; // Только в стране
            answers[1] = [3]; // Более 30 дней
            answers[2] = [2]; // Более 20 ГБ
            break;

        case 'unlimited':
            // Безлимитный интернет
            answers[0] = [0]; // Только в стране
            answers[1] = [2]; // 16-30 дней (средний срок для безлимита)
            answers[2] = [3]; // Безлимит
            break;

        case 'messengers':
            // Только мессенджеры: минимальный трафик
            answers[0] = [0]; // Только в стране
            answers[1] = [0]; // 1-7 дней
            answers[2] = [0]; // До 5 ГБ
            break;

        case 'with-number':
            // Ранее сценарий для звонков: теперь используем сбалансированный набор без требований к звонкам
            answers[0] = [0]; // Только в стране
            answers[1] = [2]; // 16-30 дней
            answers[2] = [1]; // 5-20 ГБ
            break;

        case 'regional':
            // Для соседних стран: региональное покрытие
            answers[0] = [1]; // В стране и соседних странах
            answers[1] = [2]; // 16-30 дней
            answers[2] = [1]; // 5-20 ГБ
            break;

        default:
            // Если тип сценария не распознан, возвращаем пустой объект
            break;
    }

    return answers;
}

